// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerAddressApi } from "../../services/Api/CustomerAddressApi"
import { getCustomerAddressList, getErrors } from "../reducers/CustomerAddressReducer"

// Watchers
function* customerAddressSaga() {
	yield takeEvery("customerAddress_list/getCustomerAddress", getAddress)
}

// Sagas
function* getAddress(action) {
	// console.log(action)
	try {
		const getCustomerAddress = yield call(getCustomerAddressApi, action.payload)
		
		if (getCustomerAddress.request.status === 200) {
			yield put(getCustomerAddressList(getCustomerAddress))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(customerAddressSaga)])
}
